import React from 'react';
import { CnLayoutCell as UICnLayoutCell } from '@/components/cn-layout';
const CnLayoutCell = (props) => {
    const { children } = props || {};
    return <UICnLayoutCell>{children}</UICnLayoutCell>;
};
CnLayoutCell.displayName = 'CnLayoutCell';
export default CnLayoutCell;
export { CnLayoutCell };
